import { environment } from "src/environments/environment";

export const INITIAL_ADDRESSES_DATA = (environment.mock && environment.mockAddresses) ? {
    postalCodes: ["66740"],
    postalCode: "66740",
    cities: ["Saarlouis"],
    city: "Saarlouis",
    streetNames: ["Wallerfanger Straße", "Hauptstraße", "Neuforweilerweg"],
    streetName: "Wallerfanger Straße",
    streetNumbers: ["20", "150"],
    streetNumber: "150"
} : {
    postalCodes: [],
    postalCode: "",
    cities: [],
    city: "",
    streetNames: [],
    streetName: "",
    streetNumbers: [],
    streetNumber: ""
}
